module.exports = __webpack_public_path__ + "assets/img/47fff87a68d6cd56dc0798a0a34507d0.png";